import React from "react";
import { useSelector } from "react-redux";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import * as HeaderSelectors from "@redux/modules/value/header/header.selectors";

import { HeaderButton } from "./headerButton.component";

export type HeaderButtonContainerProps = {
    icon: string;
    text: string;
    hover?: boolean;
    dropdown?: boolean;
    alerts?: number;
    invert?: boolean;
    link?: string;
    innerHTML: any;
    hiddenText?: boolean;
    ariaLabel?: string;
};

const HeaderButtonContainer = (props: HeaderButtonContainerProps) => {
    const header = useSelector(HeaderSelectors.getHeader);
    const isClient = useIsClientSide();

    return (
        <HeaderButton
            {...props}
            invert={
                props.invert || (isClient && header?.mobile)
            }
        >
            {props.innerHTML !== "" && props.innerHTML !== undefined && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: props.innerHTML,
                    }}
                />
            )}
        </HeaderButton>
    );
};

export { HeaderButtonContainer };
